import script from "./CoinsBundle.vue?vue&type=script&lang=ts&setup=true"
export * from "./CoinsBundle.vue?vue&type=script&lang=ts&setup=true"

import "./CoinsBundle.vue?vue&type=style&index=0&id=189de950&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-189de950"]])

export default __exports__